import { Component } from "@angular/core";

@Component({
  selector: "app-aurea-colours",
  templateUrl: "./aurea-colours.component.html",
  styleUrls: ["./aurea-colours.component.scss"],
})
export class AureaColoursComponent {
  colours = [
    {
      swatch: "#e63916",
      title: "Chili red",
      code: "#e63916",
    },
    {
      swatch: "#1a1508",
      title: "Smoky black",
      code: "#1a1508",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
